import {
  BasicButton,
  ButtonGroup,
  Grid,
  GridItem,
  LegacyModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  PrimaryButton,
  Text,
  Illustration,
} from "@certn/cascadia-react";
import { showPendoGuideById } from "@certn/utils";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useOverlayTriggerState } from "react-stately";

type SubmitCheckModalProps = {
  show: boolean;
  provideFeedback: boolean;
  setShowSuccessModal: any;
};

export function SubmitCheckModal({
  show,
  provideFeedback,
  setShowSuccessModal,
}: SubmitCheckModalProps) {
  const { t } = useTranslation();
  const modalState = useOverlayTriggerState({});
  const navigate = useNavigate();

  if (!show) {
    return null;
  }

  const handleClose = () => {
    setShowSuccessModal(false);
    navigate(".", { state: {}, replace: true });
    showPendoGuideById("x__BnAF6q1Q98wrpAFrZe8AtUK4");
  };

  return (
    <ModalOverlay state={modalState}>
      <LegacyModal width="456px">
        <ModalHeader
          close={handleClose}
          title={t("Background check submitted")}
        />
        <ModalContent>
          <Grid>
            <GridItem>
              <Illustration name="success" />
            </GridItem>
            <GridItem>
              <Text style="global/body-primary">
                <Trans>
                  Your background check information has been submitted, and you
                  can track your progress in the history section of your
                  dashboard.
                </Trans>
              </Text>
              {provideFeedback && (
                <Text style="global/body-primary">
                  <Trans>
                    <br />
                    If you have two minutes to spare, we’d love to hear how we
                    can improve your experience.
                  </Trans>
                </Text>
              )}
            </GridItem>
          </Grid>
        </ModalContent>

        <ModalFooter>
          <ButtonGroup>
            {provideFeedback && (
              <BasicButton size="medium">
                <Trans>Provide feedback</Trans>
              </BasicButton>
            )}
            <PrimaryButton
              type="submit"
              size="medium"
              onPress={handleClose}
              testID="submit-application-modal-close-button"
            >
              <Trans>Close</Trans>
            </PrimaryButton>
          </ButtonGroup>
        </ModalFooter>
      </LegacyModal>
    </ModalOverlay>
  );
}
